import { G_USER_MODULE, G_TASKS_MODULE, G_TEMPLATES_MODULE } from "./module.type";

export const GET = "get";
export const CACHE = "cache"
export const FETCH = "fetch";
export const WATCH = "watch";
export const FETCH_DOCUMENT = "fetch_document";
export const WATCH_DOCUMENT = "watch_document";
export const GET_FROM_MODULES = "get_from_modules";
export const ATTATCH_LISTENER = "attatch_listener";
export const MAYBE_WATCH      = "maybe_watch";

// tasks.store.js
// TODO: Change "ACTIONS" to "TASKS"
export const WATCH_GROUPS_ACTIONS     = "watch_group_actions";
export const FETCH_GROUPS_ACTIONS     = "fetch_group_actions";
export const WATCH_GROUP_ACTION       = "watch_group_action";
export const FETCH_GROUP_ACTION       = "fetch_group_action";
export const WATCH_NOTIFICATIONS      = "watch_notifications";
export const FETCH_TASK_NOTIFICATIONS = "fetch_task_notifications";
export const USER_TASK_CREATE         = "user_task_create";
export const USER_TASK_DELETE         = "user_task_delete";
export const TASK_UPDATE              = "task_update";
export const UPDATE_NOTIFICATION      = "update_notification";
export const FETCH_NOTIFICATIONS      = "fetch_notifications";

// user.store.js
export const GET_GROUP                = "get_group";
export const GET_USER_DEFAULT_CONTEXT = "user_default_context";
export const UPDATE                   = "update";
export const DELETE_AVATAR_IMAGE      = "delete_avatar_image";
export const UPDATE_AVATAR_PHOTO      = "update_avatar_photo";
export const UPLOAD_AVATAR_IMAGE      = "upload_avatar_image";
export const UPDATE_DATABASE_USER_DOC = "update_database_user_doc";
export const GET_SELECTED             = "get_selected_context";
export const SELECT_GET_DEFAULTS      = "select_get_defaults";
export const REGISTER_USER_NOTIFICATION_TOKEN = "register_user_notification_token";
export const G_REGISTER_USER_NOTIFICATION_TOKEN = `${G_USER_MODULE}/${REGISTER_USER_NOTIFICATION_TOKEN}`;

// group.store.js
export const MAYBE_REGISTER_ALL_CONTEXTS = "maybe_register_all_contexts";

// context.store.js
export const WATCH_ITEMS = "watch_items"

// Globals
export const G_ATTATCH_LISTENER = "attatch_listener";
export const G_TEMPLATES_CACHE  = `${G_TEMPLATES_MODULE}/${CACHE}`;

export const G_USER_TASKS_GET   = `${G_TASKS_MODULE}/${GET}`;
export const G_USER_TASKS_CACHE = `${G_TASKS_MODULE}/${CACHE}`;
export const G_USER_SELECT_GET_DEFAULTS = `${G_USER_MODULE}/${SELECT_GET_DEFAULTS}`;
export const G_USER_TASK_UPDATE = `${G_TASKS_MODULE}/${TASK_UPDATE}`;

export const G_GET_USER_DEFAULT_CONTEXT = `${G_USER_MODULE}/${GET_USER_DEFAULT_CONTEXT}`;

export const G_USER_TASK_CREATE = `${G_TASKS_MODULE}/${USER_TASK_CREATE}`;
export const G_USER_TASK_DELETE = `${G_TASKS_MODULE}/${USER_TASK_DELETE}`;
